/* tslint:disable */
/* eslint-disable */

import { ReaderInlineDataFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type messageHelpers_user = {
    readonly profile: {
        readonly currency: Currency | null;
    } | null;
    readonly activePromotion: {
        readonly buyerDisplayable: boolean | null;
        readonly flatAdjustmentRate: {
            readonly rate: {
                readonly convertedAmountList: ReadonlyArray<{
                    readonly amount: number | null;
                    readonly currency: Currency | null;
                } | null> | null;
            } | null;
        } | null;
        readonly code: string | null;
        readonly promotionMeta: {
            readonly customBannerMessage: boolean | null;
            readonly desktopBannerMessage: string | null;
            readonly desktopBannerCta: string | null;
            readonly mobileBannerMessage: string | null;
            readonly mobileBannerCta: string | null;
        } | null;
    } | null;
    readonly " $refType": "messageHelpers_user";
};
export type messageHelpers_user$data = messageHelpers_user;
export type messageHelpers_user$key = {
    readonly " $data"?: messageHelpers_user$data;
    readonly " $fragmentRefs": FragmentRefs<"messageHelpers_user">;
};



const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "messageHelpers_user"
};
(node as any).hash = '8bfc01a6caa0bbe68320e7e98c6b9156';
export default node;
